export default {
  namespaced: true,
  dmp: {
    title: "DMP",
    name: "Nome",
    panel_model: "Modelo",
    panel_mac_addr: "Endereço MAC",
    panel_serial_num: "Número de série",
    panel: "Painel",
    autoDetectPanel: "Detectar painel(is) automaticamente",
    autoDetectPanelHint: "Usa o(s) painel(is) da unidade do alarme automaticamente",
    dateRange: "Intervalo de dias",
    dateRangeNone: "Nenhum",
    dateRangeLast30: "Últimos 30 dias",
    dateRangeLast60: "Últimos 60 dias",
    dateRangeHint: "Calculado a partir do momento em que a vista do alarme é aberta",
    template: "Template",
    panels: "Painéis",
    host: "Host",
    port: "Porta",
    client_password: "Senha do cliente",
    remote_control_password: "Senha de controle remoto",
    listening_port: "Porta de escuta",
    facilities: "Instalações",
    eventDefinition: "Definição do evento",
    event_code: "Código do evento",
    alarm_type_sbo: "Tipo de alarme (SBO)",
    description: "Descrição",
    zone: "Zona",
    num_conact_id: "Número da conta Contact ID",
    creation_date: "Data de criação",
    isRecovered: "Recuperado",
    recovered_yes: "Sim",
    recovered_no: "Não",
    date: "Data",
    masterAccounts: "contas mestres",
    masterAccount: "conta mestre",
    first_name: "nome",
    last_name: "sobrenome",
    link: "link",
    username: "Usuário",
    token: "token",
    password: "senha",
    token_expired: "expiração do token",
    email: "e-mail",
    sites: "sites",
    site: "site",
    address: "endereço",
    latitude: "latitude",
    longitude: "longitude",
    timeZone: "fuso horário",
    profile: "perfil",
    profiles: "perfis",
    calendar: "calendário",
    serialNumber: "número de série",
    actions: "ações",
    schemaTypes: "tipos de esquema",
    schema_type: "tipo de esquema",
    display_name: "nome de exibição",
    id: "id",
    devicesSection: "dispositivos",
    gateway_id: "id do gateway",
    schema_actions: "ações do esquema",
    typeAlarm: "tipo de alarme",
    typeAlarms: "tipos de alarme",
    priority: "prioridade",
    checkRemoteUser: "verificar usuário remoto",
    dispatchAlarm: "despachar alarme",
    alarms: "alarmes",
    state: "estado",
    creation_time: "hora de criação",
    units: "instalações",
    center: "central",
    sector: "setor",
    device: "dispositivo",
    schemaEvent: "evento",
    time: "hora",
    logs: "registros",
    channel: "canal",
    name_panel: "nome do painel",
    events: "eventos",
    syncCorrectly: "sincronizado corretamente",
    status: "Status",
    instance_host: "Host da instância",
    rules: "Regras",
    code: "Código",
    event: "Evento",
    event_id: "ID do evento",
    value: "Valor",
    zones_pgm: "Zona / PGM",
    pgm_output: "PGM / Saída",
    partition: "Partição",
    alias: "Alias",
    syncPanel: "Sincronizar painel",
    syncPanelWarning: "A sincronização pode levar alguns minutos",
    syncing: "Sincronizando",
    withoutProfile: "O painel não tem um perfil atribuído",
    reconnect: "Reconectar",
    restart: "Reiniciar",
    rebuild: "Reconstruir",
    profile_name: "Perfil",
    type: "Tipo",
    category: "Categoria",
    active: "Ativo",
    activate: "Ativar",
    deactivate: "Desativar",
    close: "Fechar",
    open: "Abrir",
    bypass: "Bypass",
    enable: "Habilitar",
    panelOffline: "O painel está offline",
    panelStatusArmed: "Armado",
    panelStatusDisarmed: "Desarmado",
    panelStatusOffline: "Offline",
    arm: "Armar",
    disarm: "Desarmar",
    armPanel: "Armar painel",
    disarmPanel: "Desarmar painel",
    arming: "Armando",
    disarming: "Desarmando",
    armedCorrectly: "Armado corretamente",
    disarmedCorrectly: "Desarmado corretamente",
    uuid: "UUID",
    connected: "Conectado",
    disconnected: "Desconectado",
    deviceType: 'Tipo de dispositivo',
    deviceId: "ID do dispositivo",
    deviceName: "Nome do dispositivo",
    eventType: "Tipo de evento",
    areaId: "ID da área",
    userId: "ID do usuário",
    alarmType: "Tipo de alarme",
    areaArmed: "Armada",
    areaDisarmed: "Desarmada",
    enabled: "Habilitado",
    disabled: "Desabilitado",
    area: "Área",
    eventDate: "Data do evento",
    servers: "Servidores",
    url: "URL",
    count: "Núm. de instâncias",
    panelHost: "Host do painel",
    panelAccount: "Conta do painel",
    panelRemoteKey: "Chave remota do painel",
    alarmId: "ID do alarme",
    activating: "Ativando",
    deactivating: "Desativando",
    saving: "Salvando...",
    syncDevices: "Sincronizar dispositivos",
    syncDevicesSuccess: "Dispositivos sincronizados com sucesso",
    syncDevicesError: "Erro ao sincronizar os dispositivos",
    tag: "Etiqueta",
    tags: "Etiquetas",
    searchResults: "Resultados da busca",
    noResults: "Sem resultados",
    required: "Obrigatório",
    isRecovered: "Recuperado",
    enabled_zones_audit: "Habilitar auditoria de zonas",
    days_zones_audit: "Dias de auditoria de zonas",
    enabled_areas_audit: "Habilitar auditoria de áreas",
    days_areas_audit: "Dias de auditoria de áreas",
    dateAndTimezone: "Data e fuso horário",
    current: "Atual",
    messages: {
      executeCommandConfirm: "Executar o comando '%command%' em '%device%'?",
      commandExecutedSuccess: "comando '%command%' executado com sucesso",
      commandExecutedError: "erro ao executar o comando '%command%'",
      areYouSureTo: "Tem certeza de que deseja %action% %device%?",
      areYouSure: "Tem certeza de que deseja executar '%action%' em %device%?",
      categoryGroupChangeWarning: "Aplicar a categoria a todos os itens, inclusive aos que já têm uma diferente?",
      tagAppliedSuccess: "Etiqueta aplicada com sucesso",
      areaTagApplyToZones: "Aplicar esta etiqueta também a todas as zonas da área? As etiquetas atuais serão substituídas.",
      areaTagRemoveFromZones: "Remover também as etiquetas de todas as zonas da área?",
      areaTagIncludeZones: "Sim, também as zonas",
      areaTagOnlyArea: "Não, somente a área",
      tagRemovedSuccess: "Etiqueta removida com sucesso",
    },
    devices: {
      area: {
        actions: {
          Arm: 'Armada',
          Disarm: 'Desarmada'
        },
        title: 'área'
      },
      output: {
        actions: {
          Momentary: 'momentânea',
          Off: 'desligada',
          Pulse: 'pulsada',
          Steady: 'fixa',
          'Temporal 3': 'Temporal 3'
        },
        title: 'saída'
      },
      zone: {
        actions: {
          Bypass: 'bypass',
          Reset: 'reiniciar'
        },
        title: 'zona'
      },
      zone24h: {
        actions: {
          Bypass: 'bypass',
          Reset: 'reiniciar'
        },
        title: 'zona 24h'
      },
      panel: {
        title: 'painel',
        actions: {
          'Arm Panel': 'Armar painel',
          'Disarm Panel': 'Desarmar painel',
          'Alarm silence': 'Silenciar alarme',
          'Sensor reset': 'Reiniciar sensores'
        }
      },
      door: {
        title: 'porta',
        actions: {
          'Door Access': 'Acesso à porta',
          'Lock Door': 'Bloquear porta',
          'Unlock Door': 'Desbloquear porta'
        }
      }
    },
    deviceStatuses: {
      ARMED: 'Armado',
      DISARMED: 'Desarmado',
      NORMAL: 'Normal',
      OPEN: 'Aberto',
      BYPASSED: 'Em bypass',
      OFF: 'Desligado',
      ON: 'Ligado',
      OFFLINE: 'Offline',
      ONLINE: 'Online',
      LOCKED: 'Bloqueado',
      UNLOCKED: 'Desbloqueado',
      TROUBLE: 'Falha',
    },
    panelInfo: {
      panel: 'Painel',
      tamper: 'Tamper',
      acPower: 'Alimentação CA',
      battery: 'Bateria',
      printer: 'Impressora',
      wireless: 'Sem fio',
      phoneLine1: 'Linha telefônica 1',
      phoneLine2: 'Linha telefônica 2',
    },
    wizard: {
      add: {
        title: "Assistente para adicionar DMP",
      },
      edit: {
        title: "Assistente para editar DMP",
      },
      steps: {
        general: "Geral",
        users: "Usuários",
        communicationPaths: "Caminhos de comunicação",
      }
    },
    config: "Configuração",
    configSections: {
      users: "Usuários",
      communicationPaths: "Caminhos de Comunicação",
      general: "Configurações Gerais",
      areaInformation: "Informações de Áreas",
      outputInformation: "Informações de Saídas",
      deviceSetup: "Configuração de Dispositivos",
      outputOptions: "Opções de Saída",
      areaSchedules: "Horários de Áreas",
      timeSchedules: "Horários",
      bellOptions: "Opções de Campainha",
      networkOptions: "Opções de Rede",
      remoteOptions: "Opções Remotas",
      holidayDates: "Datas de Feriado",
      outputGroups: "Grupos de Saída",
      systemOptions: "Opções do Sistema",
      profiles: "Perfis",
      zoneInformation: "Informações de Zonas",
    },
    outputInformation: {
      title: "Informações de saídas",
      outputs: "Saídas",
      addOutput: "Adicionar saída",
      editOutput: "Editar saída",
      noOutputsConfigured: "Nenhuma saída configurada",
      outputNumber: "Número da saída",
      outputName: "Nome da saída",
      outputDetails: "Detalhes da saída",
      description: "Descrição",
      loadingOutputs: "Carregando saídas...",
      messages: {
        deleteConfirm: "Tem certeza de que deseja excluir esta saída?",
        limitReached: "Limite atingido",
        maxOutputsAllowed: "Número máximo de saídas permitidas",
        validationError: "Erro de validação",
        outputNumberExists: "O número da saída já existe",
        outputSavedSuccess: "Saída salva com sucesso",
        outputsLoadError: "Não foi possível carregar as saídas",
        outputDeleteSuccess: "Saída excluída com sucesso",
        outputDeleteError: "Não foi possível excluir a saída",
        outputSaveError: "Não foi possível salvar a saída",
        outputAddedSuccess: "Saída adicionada com sucesso",
        outputUpdatedSuccess: "Saída atualizada com sucesso",
        syncSuccess: "Saídas sincronizadas com sucesso",
        syncError: "Não foi possível sincronizar as saídas"
      }
    },
    outputGroups: {
      title: "Grupos de saída",
      groups: "Grupos",
      addGroup: "Adicionar grupo",
      editGroup: "Editar grupo",
      noGroupsConfigured: "Nenhum grupo configurado",
      groupNumber: "Número do grupo",
      groupName: "Nome do grupo",
      messages: {
        deleteConfirm: "Tem certeza de que deseja excluir este grupo?",
        limitReached: "Limite atingido",
        maxGroupsAllowed: "Número máximo de grupos permitidos",
        validationError: "Erro de validação",
        groupNumberExists: "O número do grupo já existe",
        groupSavedSuccess: "Grupo salvo com sucesso",
        groupsLoadError: "Não foi possível carregar os grupos",
        groupDeleteSuccess: "Grupo excluído com sucesso",
        groupDeleteError: "Não foi possível excluir o grupo",
        groupSaveError: "Não foi possível salvar o grupo"
      }
    },
    outputOptions: {
      title: "Opções de saída",
      settings: "Configurações",
      save: "Salvar alterações",
      options: "Opções",
      energySaving: "Economia de energia",
      outputs: "Saídas",
      cutoffOutputs: "Saídas de corte",
      cutoffOutputsRange: "Intervalo: 0, 1-6",
      cutoffTime: "Tempo de corte",
      cutoffTimeRange: "Intervalo: 0, 55-95",
      heatSaverTemp: "Temperatura de economia de aquecimento",
      coolSaverTemp: "Temperatura de economia de refrigeração",
      temperatureRange: "Intervalo: 0, 55-95",
      commFailOutput: "Saída por falha de comunicação",
      fireAlarmOutput: "Saída de alarme de incêndio",
      fireTroubleOutput: "Saída de falha de incêndio",
      panicAlarmOutput: "Saída de alarme de pânico",
      ambushOutput: "Saída de coação",
      entryDelayOutput: "Saída de retardo de entrada",
      beginExitOutput: "Saída de início de saída",
      endExitOutput: "Saída de fim de saída",
      readyOutput: "Saída de pronto",
      phoneTroubleOutput: "Saída de falha telefônica",
      lateToCloseOutput: "Saída de fechamento atrasado",
      deviceFailedOutput: "Saída de dispositivo com falha",
      sensorResetOutput: "Saída de reinício de sensores",
      closingWaitOutput: "Saída de espera de fechamento",
      disarmedOutput: "Saída de desarmado",
      armAlarmOutput: "Saída de alarme de armado",
      supervisoryAlarmOutput: "Saída de alarme de supervisão",
      armedHomePerimeterOutput: "Saída Casa/Perímetro",
      armedAllAwayOutput: "Saída Tudo/Ausente",
      armedSleepOutput: "Saída Dormir",
      carbonMonoxideOutput: "Saída de monóxido de carbono",
      lockdownOutput: "Saída de bloqueio",
      zoneMonitorOutput: "Saída de monitor de zonas",
      loadingOutputs: "Carregando opções de saída...",
      messages: {
        saveSuccess: "Opções de saída salvas com sucesso",
        saveError: "Não foi possível salvar as opções de saída",
        loadError: "Não foi possível carregar as opções de saída",
        syncSuccess: "Opções de saída sincronizadas com sucesso",
        syncError: "Não foi possível sincronizar as opções de saída"
      }
    },
    systemOptions: {
      title: "Opções do sistema",
      settings: "Configurações",
      save: "Salvar alterações",
      saving: "Salvando...",
      options: "Opções",
      miscellaneousOptions: "Opções diversas",
      languages: "Idiomas",
      timeChange: "Mudança de hora",
      delays: "Retardos",
      wireless: "Sem fio",
      advancedOptions: "Opções avançadas",
      systemArmingType: "Tipo de armamento do sistema",
      instantArm: "Armamento instantâneo",
      closingWait: "Espera de fechamento",
      resetSwingerBypass: "Reiniciar swinger bypass",
      enableKeypadPanicKeys: "Habilitar teclas de pânico do teclado",
      enhancedZoneTest: "Teste de zonas aprimorado",
      send16Characters: "Enviar nomes de 16 caracteres",
      useFalseAlarmQuestion: "Usar pergunta de alarme falso",
      allowOwnUserCodeChange: "Permitir alterar o próprio código de usuário",
      panicSupervision: "Supervisão de pânico",
      keypadArmedLed: "LED de armado do teclado",
      swingerBypassTrips: "Disparos para swinger bypass",
      bypassLimit: "Limite de bypass",
      weatherZipCode: "CEP do clima",
      occupiedPremises: "Local ocupado",
      primaryProgrammingLang: "Idioma principal de programação",
      secondaryProgrammingLang: "Idioma secundário de programação",
      primaryUserLang: "Idioma principal do usuário",
      secondaryUserLang: "Idioma secundário do usuário",
      hoursFromGMT: "Horas a partir do GMT",
      timeChangeOption: "Mudança de hora",
      zoneActivityHours: "Horas de atividade de zonas",
      entryDelay1: "Retardo de entrada 1",
      entryDelay2: "Retardo de entrada 2",
      entryDelay3: "Retardo de entrada 3",
      entryDelay4: "Retardo de entrada 4",
      crossZoneTime: "Tempo de zona cruzada",
      zoneRetardDelay: "Retardo de zona",
      powerFailDelay: "Retardo por falha de energia",
      wirelessHouseCode: "Código de casa sem fio",
      troubleAudible: "Falha audível",
      detectWirelessJamming: "Detectar interferência sem fio",
      latchSupervisory: "Reter supervisão",
      eolResistor: "Seletor de resistor EOL",
      useCelsiusTemperature: "Temperatura em Celsius",
      observeDST: "Aplicar horário de verão",
      encryptionSettings: "Criptografia sem fio 1100",
      encryptionPassphrase: "Frase-senha 1100",
      loadingSystemOptions: "Carregando opções do sistema...",
      timeChangeOptions: {
        receiver: "Receptor",
        noChange: "Sem mudança de hora",
        secureCom: "SecureCom",
      },
      encryptionSettingsOptions: {
        none: "Nenhum",
        all: "Todos",
        both: "Ambos"
      },
      armingTypes: {
        area: "Área",
        all: "Tudo",
        guest: "Convidado",
        home: "Casa"
      },
      keypadLedOptions: {
        any: "Qualquer",
        day: "Dia",
        minimum: "Mínimo"
      },
      languages: {
        title: "Idiomas",
        none: "Nenhum",
        english: "Inglês",
        spanish: "Espanhol",
        french: "Francês",
        czech: "Tcheco",
        greek: "Grego",
        dutch: "Holandês"
      },
      troubleAudibleOptions: {
        any: "Qualquer",
        day: "Dia",
        minimum: "Mín"
      },
      messages: {
        saveSuccess: "Opções do sistema salvas com sucesso",
        saveError: "Não foi possível salvar as opções do sistema",
        loadError: "Não foi possível carregar as opções do sistema",
        validationError: "Erro de validação",
        validationErrorText: "Corrija os erros do formulário",
        syncSuccess: "Opções do sistema sincronizadas com sucesso",
        syncError: "Não foi possível sincronizar as opções do sistema"
      }
    },
    areaInformation: {
      globalSettings: "Configurações globais (aplicam-se a todas as áreas)",
      saveGlobalSettings: "Salvar configurações globais",
      exitDelay: "Retardo de saída",
      burglaryBellOutput: "Saída de campainha de roubo",
      earlyMorningAmbush: "Coação de madrugada",
      closingCheck: "Verificação de fechamento",
      areaSchedules: "Horários de áreas",
      closingCode: "Código de fechamento",
      anyBypass: "Qualquer bypass",
      areas: "Áreas",
      addArea: "Adicionar área",
      editArea: "Editar área",
      noAreasConfigured: "Nenhuma área configurada",
      loadingAreas: "Carregando áreas...",
      areaDetails: "Detalhes da área",
      areaNumber: "Número da área",
      areaName: "Nome da área",
      accountNumber: "Número da conta",
      accountNumberHint: "Número de conta de 4 dígitos (opcional)",
      badZones: "Zonas em falha",
      armedOutput: "Saída de armado",
      lateOutput: "Saída por atraso",
      lateArmDelay: "Retardo de armamento tardio",
      twoManRule: "Regra de duas pessoas",
      options: "Opções",
      openCloseReports: "Relatórios de abertura/fechamento",
      autoArming: "Armamento automático",
      autoDisarm: "Desarmamento automático",
      bankSafeAndVault: "Cofre e caixa-forte",
      commonArea: "Área comum",
      armFirst: "Armar primeiro",
      cardPin: "Cartão + PIN",
      bypassOptions: {
        bypass: "Bypass",
        forceArm: "Armamento forçado",
        refuseArm: "Recusar armamento"
      },
      noYes: {
        no: "Não",
        yes: "Sim"
      },
      messages: {
        deleteConfirm: "Tem certeza de que deseja excluir esta área?",
        deleteConfirmText: "Esta ação não pode ser desfeita",
        limitReached: "Limite atingido",
        maxAreasAllowed: "Máximo de 99 áreas permitidas",
        validationError: "Erro de validação",
        areaNumberExists: "O número da área já existe",
        globalSettingsSaved: "Configurações globais salvas com sucesso",
        globalSettingsError: "Não foi possível salvar as configurações globais",
        areasSavedSuccess: "Área salva com sucesso",
        areaAddedSuccess: "Área adicionada com sucesso",
        areaUpdatedSuccess: "Área atualizada com sucesso",
        areasLoadError: "Não foi possível carregar as áreas",
        areasReloadSuccess: "Áreas recarregadas com sucesso",
        areasReloadError: "Não foi possível recarregar as áreas. Tente novamente.",
        areaDeleteSuccess: "Área excluída com sucesso",
        areaDeleteError: "Não foi possível excluir a área",
        areaSaveError: "Não foi possível salvar a área",
        syncSuccess: "Áreas sincronizadas com sucesso",
        syncError: "Não foi possível sincronizar as áreas"
      }
    },
    outputGroups: {
      title: "Grupos de saída",
      groups: "Grupos",
      addGroup: "Adicionar grupo",
      editGroup: "Editar grupo",
      groupDetails: "Detalhes do grupo de saída",
      noGroupsConfigured: "Nenhum grupo configurado",
      groupNumber: "Número do grupo",
      groupName: "Nome do grupo",
      outputNumber: "Número da saída",
      loadingGroups: "Carregando grupos de saída...",
      messages: {
        deleteConfirm: "Excluir grupo",
        deleteConfirmText: "Tem certeza de que deseja excluir este grupo de saída?",
        limitReached: "Limite atingido",
        maxGroupsAllowed: "Número máximo de grupos permitidos",
        validationError: "Erro de validação",
        groupNumberExists: "O número do grupo já existe",
        groupAddedSuccess: "Grupo de saída adicionado com sucesso",
        groupUpdatedSuccess: "Grupo de saída atualizado com sucesso",
        groupSavedSuccess: "Grupo de saída salvo com sucesso",
        groupsLoadError: "Não foi possível carregar os grupos de saída",
        groupDeleteSuccess: "Grupo de saída excluído com sucesso",
        groupDeleteError: "Não foi possível excluir o grupo de saída",
        groupSaveError: "Não foi possível salvar o grupo de saída",
        atLeastOneOutput: "É necessário configurar ao menos uma saída para o grupo",
        syncSuccess: "Grupos de saída sincronizados com sucesso",
        syncError: "Não foi possível sincronizar os grupos de saída"
      }
    },
    holidayDates: {
      title: "Datas de feriado",
      addHoliday: "Adicionar feriado",
      editHoliday: "Editar feriado",
      noHolidaysConfigured: "Nenhuma data de feriado configurada",
      loadingHolidays: "Carregando feriados...",
      number: "Número",
      name: "Nome",
      class: "Classe",
      date: "Data",
      holidayDate: "Data do feriado",
      description: "Descrição",
      selectClass: "Selecione uma classe",
      holidayDetails: "Detalhes do feriado",
      messages: {
        deleteConfirm: "Tem certeza de que deseja excluir este feriado?",
        limitReached: "Limite atingido",
        maxHolidaysAllowed: "Máximo de 99 feriados permitidos",
        validationError: "Erro de validação",
        validationErrorText: "Preencha corretamente todos os campos obrigatórios",
        numberExists: "O número do feriado já existe",
        dateExists: "Esta data já existe",
        saveSuccess: "Feriado salvo com sucesso",
        saveError: "Não foi possível salvar o feriado",
        loadError: "Não foi possível carregar as datas de feriado",
        deleteSuccess: "Feriado excluído com sucesso",
        deleteError: "Não foi possível excluir o feriado",
        syncSuccess: "Datas de feriado sincronizadas com sucesso",
        syncError: "Não foi possível sincronizar as datas de feriado"
      }
    },
    users: {
      title: "Usuários",
      configuredUsers: "Usuários configurados",
      addUser: "Adicionar usuário",
      editUser: "Editar usuário",
      noUsersConfigured: "Nenhum usuário configurado",
      loadingUsers: "Carregando usuários...",
      userNumber: "Número",
      userCode: "Código",
      userName: "Nome",
      userPin: "PIN do usuário",
      activeUser: "Usuário ativo",
      status: "Status",
      active: "Ativo",
      inactive: "Inativo",
      profiles: "Perfis",
      noProfiles: "Sem perfis",
      noProfile: "Não atribuído",
      profile: "Perfil",
      range: "Intervalo: 1-9999",
      userCodeHint: "0-9a-z, máx. 12",
      userPinHint: "6 dígitos (opcional)",
      userNameHint: "Máx. 20",
      userDetails: "Detalhes do usuário",
      messages: {
        deleteConfirm: "Tem certeza de que deseja excluir este usuário?",
        userSavedSuccess: "Usuário salvo com sucesso",
        userAddedSuccess: "Usuário adicionado com sucesso",
        userUpdatedSuccess: "Usuário atualizado com sucesso",
        userDeleteSuccess: "Usuário excluído com sucesso",
        usersLoadError: "Não foi possível carregar os usuários",
        userSaveError: "Não foi possível salvar o usuário",
        userDeleteError: "Não foi possível excluir o usuário",
        pinMustBe6Digits: "O PIN deve ter exatamente 6 dígitos ou estar vazio",
        userCodeOnlyAlphanumeric: "O código de usuário só pode conter números e letras minúsculas",
        profileOnlyNumbers: "O perfil {number} só pode conter números (1-3 dígitos)",
        userNumberExists: "O número de usuário já existe",
        userCodeExists: "O código de usuário já existe",
        atLeastOneProfile: "É necessário informar ao menos um perfil"
      }
    },
    communicationPaths: {
      title: "Caminhos de comunicação",
      addPath: "Adicionar caminho",
      editPath: "Editar caminho de comunicação",
      addCommunicationPath: "Adicionar caminho de comunicação",
      editCommunicationPath: "Editar caminho de comunicação",
      noPathsConfigured: "Nenhum caminho de comunicação configurado",
      loadingPaths: "Carregando caminhos...",
      communicationPathDetails: "Detalhes do caminho de comunicação",
      pathNumber: "Número do caminho",
      receiverIp: "IP do receptor",
      receiverPort: "Porta do receptor",
      protocol: "Protocolo",
      accountNumber: "Número da conta",
      communicationTrouble: "Falha de comunicação",
      doorAccess: "Acesso a portas",
      selectProtocol: "Selecione o protocolo",
      selectOption: "Selecione uma opção",
      tcp: "TCP",
      udp: "UDP",
      yes: "Sim",
      no: "Não",
      deny: "Negar",
      pathNumberHint: "Informe o número do caminho (1-8)",
      receiverIpHint: "Informe o endereço IP do receptor",
      receiverPortHint: "Porta",
      accountNumberHint: "Número de conta de 4 dígitos (opcional)",
      messages: {
        deleteConfirm: "Tem certeza de que deseja excluir este caminho de comunicação?",
        deleteConfirmText: "Esta ação não pode ser desfeita",
        limitReached: "Limite atingido",
        maxPathsAllowed: "Máximo de 8 caminhos de comunicação permitidos",
        pathSavedSuccess: "Caminho de comunicação salvo com sucesso",
        pathCreatedSuccess: "Caminho de comunicação criado com sucesso",
        pathUpdatedSuccess: "Caminho de comunicação atualizado com sucesso",
        pathDeleteSuccess: "Caminho de comunicação excluído com sucesso",
        pathsLoadError: "Não foi possível carregar os caminhos de comunicação",
        pathSaveError: "Não foi possível salvar o caminho de comunicação",
        pathDeleteError: "Não foi possível excluir o caminho de comunicação",
        validationError: "Erro de validação",
        pathNumberExists: "O número do caminho já existe",
        ipPortExists: "A combinação de IP e porta já existe",
        syncSuccess: "Caminhos de comunicação sincronizados com sucesso",
        syncError: "Não foi possível sincronizar os caminhos de comunicação"
      }
    },
    remoteOptions: {
      title: "Opções remotas",
      save: "Salvar alterações",
      saving: "Salvando...",
      standard: "Padrão",
      entre: "Entré",
      general: "Geral",
      dialer: "Discador",
      network: "Rede",
      cellular: "Celular",
      mobileApplication: "Aplicativo móvel",
      programSync: "Sincronização de programação",
      entreSettings: "Configurações do Entré",
      remoteKey: "Chave remota",
      remoteDisarm: "Desarmamento remoto",
      armedAnswerRings: "Toques para atender armado",
      disarmedAnswerRings: "Toques para atender desarmado",
      pcModem: "Modem do PC",
      alarmReceiver: "Receptor de alarmes",
      serviceReceiver: "Receptor de serviço",
      allowNetworkRemote: "Permitir remoto pela rede",
      encryptNetworkRemote: "Criptografar remoto pela rede",
      encryptNetworkRemoteWarning: "Aviso: habilitar esta opção pode desconectar o painel.",
      networkProgrammingPort: "Porta de programação pela rede",
      allowCellularRemote: "Permitir remoto por celular",
      encryptCellRemote: "Criptografar remoto por celular",
      encryptCellRemoteWarning: "Aviso: habilitar esta opção pode desconectar o painel.",
      firstGprsApn: "Primeiro APN GPRS",
      secondGprsApn: "Segundo APN GPRS",
      appKey: "Chave do aplicativo",
      sendLocalChanges: "Enviar alterações locais",
      remoteChangeIp: "IP de alterações remotas",
      remoteChangePort: "Porta de alterações remotas",
      remotePhoneNumber: "Número de telefone remoto",
      entreConnection: "Conexão Entré",
      entreIncomingTcpPort: "Porta TCP de entrada do Entré",
      entreIp: "IP do Entré",
      entreOutboundTcpPort: "Porta TCP de saída do Entré",
      entreBackupIp: "IP de backup do Entré",
      entreBackupTcpPort: "Porta TCP de backup do Entré",
      entreArmDisarmReports: "Relatórios de armamento/desarmamento do Entré",
      entreZoneReports: "Relatórios de zonas do Entré",
      entreUserCommandReports: "Relatórios de comandos de usuário do Entré",
      entreDoorReports: "Relatórios de acesso a portas do Entré",
      entreSupervisoryReports: "Relatórios de supervisão do Entré",
      entreCheckInMinutes: "Minutos de check-in do Entré",
      entrePassphrase: "Frase-senha do Entré",
      none: "Nenhum",
      yes: "Sim",
      no: "Não",
      dd: "DD",
      loadingRemoteOptions: "Carregando opções remotas...",
      messages: {
        saveSuccess: "Opções remotas salvas com sucesso",
        saveError: "Não foi possível salvar as opções remotas",
        loadError: "Não foi possível carregar as opções remotas",
        validationError: "Erro de validação",
        validationErrorText: "Corrija os erros do formulário antes de salvar",
        invalidIpFormat: "Formato de endereço IP inválido",
        syncSuccess: "Opções remotas sincronizadas com sucesso",
        syncError: "Não foi possível sincronizar as opções remotas"
      }
    },
    bellOptions: {
      title: "Opções de campainha",
      optionsSection: "Opções",
      miscellaneousOptions: "Opções diversas",
      fireBellAction: "Ação da campainha de incêndio",
      burglaryBellAction: "Ação da campainha de roubo",
      supervisoryBellAction: "Ação da campainha de supervisão",
      panicBellAction: "Ação da campainha de pânico",
      emergencyBellAction: "Ação da campainha de emergência",
      aux1BellAction: "Ação da campainha Aux 1",
      aux2BellAction: "Ação da campainha Aux 2",
      carbonMonoxideAction: "Ação de monóxido de carbono",
      bellCutoffTime: "Tempo de corte da campainha",
      bellCutoffTimeHint: "Intervalo: 1-99",
      automaticBellTest: "Teste automático da campainha",
      bellOutput: "Saída da campainha",
      bellOutputHint: "Formato: 000-999",
      loading: "Carregando opções de campainha",
      actions: {
        none: "Nenhuma",
        steady: "Fixa",
        pulse: "Pulsada",
        temporal3: "Temporal 3",
        temporal4: "Temporal 4",
      },
      savedSuccessfully: "Opções de campainha salvas com sucesso",
      errorSaving: "Erro ao salvar as opções de campainha",
    },
    networkOptions: {
      title: "Opções de rede",
      options: "Opções",
      wifiSettings: "Configurações de Wi-Fi",
      localIp: "Endereço IP local",
      gateway: "Endereço do gateway",
      subnetMask: "Máscara de sub-rede",
      dnsServer: "Servidor DNS",
      encryptionPassphrase: "Frase-senha de criptografia",
      listenPort734n: "Porta de escuta 734N",
      passphrase734n: "Frase-senha 734N",
      ssid: "SSID",
      security: "Segurança",
      wifiPassword: "Senha do Wi-Fi",
      securityNone: "Nenhuma",
      securityWep: "WEP",
      securityWpa: "WPA",
      dhcp: "DHCP",
      dhcpWarning: "Aviso: habilitar esta opção pode desconectar o painel.",
      loadingNetworkOptions: "Carregando opções de rede...",
      messages: {
        saveSuccess: "Opções de rede salvas com sucesso",
        saveError: "Não foi possível salvar as opções de rede",
        loadError: "Não foi possível carregar as opções de rede",
        validationError: "Erro de validação",
        validationErrorText: "Corrija os erros do formulário",
        syncSuccess: "Opções de rede sincronizadas com sucesso",
        syncError: "Não foi possível sincronizar as opções de rede"
      }
    },
    common: {
      success: "Sucesso",
      error: "Erro",
      loading: "Carregando informações do painel",
      panelNotFound: "Painel não encontrado",
      panelNotFoundMessage: "Não foi possível encontrar o painel solicitado",
      no: "Não",
      yes: "Sim"
    },
    profiles: {
      title: "Perfis",
      configuredProfiles: "Perfis configurados",
      addProfile: "Adicionar perfil",
      editProfile: "Editar perfil",
      deleteProfile: "Excluir perfil",
      noProfilesConfigured: "Nenhum perfil configurado",
      loadingProfiles: "Carregando perfis...",
      profileNumber: "Número",
      profileName: "Nome",
      name: "Nome",
      number: "Número",
      profileNumberHint: "Intervalo: 1-99",
      profileNameHint: "Máx. 20 caracteres",
      profileDetails: "Detalhes do perfil",
      generalSettings: "Configurações gerais",
      areasAccess: "Áreas e acesso",
      schedules: "Horários",
      permissions: "Permissões",
      armDisarmAreas: "Áreas para armar/desarmar",
      armDisarmAreasHint: "Áreas que este perfil pode armar/desarmar",
      accessAreas: "Áreas de acesso",
      accessAreasHint: "Áreas às quais este perfil tem acesso",
      outputGroup: "Grupo de saída",
      outputGroupHint: "Intervalo: 0-99",
      reArmDelay: "Retardo de rearmamento",
      reArmDelayHint: "Retardo em minutos (0-999)",
      inactiveUserAuditDays: "Dias de auditoria de usuários inativos",
      inactiveUserAuditDaysHint: "Dias antes de marcar usuários inativos (0-999)",
      schedule: "Horário",
      arm: "Armar",
      disarm: "Desarmar",
      alarmSilence: "Silenciar alarme",
      lockdown: "Bloqueio",
      doorLockUnlock: "Bloquear/desbloquear porta",
      sensorReset: "Reinício de sensores",
      doorAccess: "Acesso a portas",
      armedAreas: "Áreas armadas",
      outputsOnOff: "Ligar/desligar saídas",
      zoneStatus: "Status das zonas",
      bypassZones: "Zonas em bypass",
      zoneMonitor: "Monitor de zonas",
      systemStatus: "Status do sistema",
      systemTest: "Teste do sistema",
      userCodes: "Códigos de usuário",
      setTime: "Ajustar hora",
      displayEvents: "Exibir eventos",
      serviceRequest: "Solicitação de serviço",
      fireDrill: "Simulado de incêndio",
      extend: "Estender",
      tempCode: "Código temporário",
      antiPassback: "Anti-passback",
      easyArmDisarm: "Armamento/desarmamento fácil",
      useSecondaryLanguage: "Usar idioma secundário",
      cardPlusPIN: "Cartão + PIN",
      wiFiSetup: "Configuração de Wi-Fi",
      technicianUser: "Usuário técnico",
      lockdownOverride: "Anulação de bloqueio",
      dualAuthority: "Dupla autoridade",
      privateDoors: "Portas privadas",
      privateDoor: "Porta privada",
      noSchedule: "Não atribuído",
      noDoor: "Não atribuído",
      messages: {
        deleteConfirm: "Tem certeza de que deseja excluir este perfil?",
        deleteConfirmText: "Esta ação não pode ser desfeita",
        limitReached: "Limite atingido",
        maxProfilesAllowed: "Máximo de 99 perfis permitidos",
        validationError: "Erro de validação",
        validationErrorText: "Corrija os erros do formulário",
        profileNumberExists: "O número do perfil já existe",
        profileSavedSuccess: "Perfil salvo com sucesso",
        profileCreatedSuccess: "Perfil criado com sucesso",
        profileUpdatedSuccess: "Perfil atualizado com sucesso",
        profileDeleteSuccess: "Perfil excluído com sucesso",
        profilesLoadError: "Não foi possível carregar os perfis",
        profileSaveError: "Não foi possível salvar o perfil",
        profileDeleteError: "Não foi possível excluir o perfil",
        syncSuccess: "Perfis sincronizados com sucesso",
        syncError: "Não foi possível sincronizar os perfis"
      }
    },
    zoneInformation: {
      title: "Informações de zonas",
      None: "Nenhuma",
      zones: "Zonas",
      zoneDetails: "Detalhes da zona",
      standard: "Padrão",
      action: "Ação",
      wirelessVPlex: "Sem fio/VPlex",
      advanced: "Avançado",
      addZone: "Adicionar zona",
      editZone: "Editar zona",
      noZonesConfigured: "Nenhuma zona configurada",
      loadingZones: "Carregando zonas...",
      maxZonesReached: "Limite de zonas atingido (999)",

      // Standard tab
      zoneNumber: "Número da zona",
      zoneName: "Nome da zona",
      zoneType: "Tipo",
      zoneTypeOptions: {
        none: "Nenhum",
        night: "Noite",
        day: "Dia",
        exit: "Saída",
        fire: "Incêndio",
        supervisory: "Supervisão",
        fireVerify: "Verificação de incêndio",
        panic: "Pânico",
        arming: "Armamento",
        auxiliary1: "Auxiliar 1",
        auxiliary2: "Auxiliar 2",
        emergency: "Emergência",
      },
      area: "Área",
      unassigned: "*SEM USO*",
      followArea: "Seguir área",
      armedAreas: "Áreas armadas",
      armedAreasHint: "Números de área separados por vírgulas",
      expanderSerialNumber: "Número de série do expansor",
      zoneLocation: "Localização da zona",

      // Action tab
      doMessage: "Mensagem DO",
      doOutputFireBell: "Saída DO da campainha de incêndio",
      doOutputAction: "Ação da saída DO",
      dsMessage: "Mensagem DS",
      dsOutput: "Saída DS",
      dsOutputAction: "Ação da saída DS",
      aoMessage: "Mensagem AO",
      aoOutput: "Saída AO",
      aoOutputAction: "Ação da saída AO",
      asMessage: "Mensagem AS",
      asOutput: "Saída AS",
      asOutputAction: "Ação da saída AS",

      // Message options
      messageOptions: {
        trouble: "Falha",
        alarm: "Alarme",
        supervisory: "Supervisão",
        none: "Nenhum"
      },

      // Output action options
      outputActionOptions: {
        steady: "Fixa",
        pulse: "Pulsada",
        latch: "Retida"
      },

      // Wireless tab
      wireless: "Sem fio",
      serialNumber: "Número de série",
      contact: "Contato",
      normallyOpen: "Normalmente aberto",
      supervisionTime: "Tempo de supervisão",
      ledOperation: "Operação do LED",
      disarmDisable: "Desabilitar ao desarmar",
      wirelessPirPulseCount: "Contagem de pulsos do PIR sem fio",
      wirelessPirPulseSensitivity: "Sensibilidade de pulsos do PIR sem fio",
      wirelessPirPetImmunity: "Imunidade a animais do PIR sem fio",

      // Sensitivity options
      sensitivityOptions: {
        low: "Baixa",
        medium: "Média",
        high: "Alta"
      },

      // Pet immunity options
      petImmunityOptions: {
        full: "Completa",
        partial: "Parcial",
        none: "Nenhuma"
      },

      // Wireless device types
      deviceTypes: {
        unknown: "Desconhecido",
        universal: "Transmissor universal (1000000-1999999)",
        pir: "Detector de movimento PIR (2000000-2999999)",
        glassbreak: "Detector de quebra de vidro (3000000-3999999)",
        holdup: "Botão de assalto (4000000-4999999)",
        keyfob: "Chaveiro (5000000-5999999)",
        smoke_co: "Detector de fumaça/CO (6000000-7999999)",
        four_zone_expander: "Expansor de 4 zonas (8000000-8999999)",
        wireless_pir: "PIR sem fio (9000000-9999999)",
        repeater_1100r: "Repetidor 1100R (13000000-13999999)"
      },

      // Advanced tab
      swingerBypass: "Swinger bypass",
      zoneRetard: "Retardo de zona",
      fastResponse: "Resposta rápida",
      crossZone: "Zona cruzada",
      priority: "Prioridade",
      firePanelSlaveInput: "Entrada escrava do painel de incêndio",
      zoneRealTimeStatus: "Status da zona em tempo real",
      trafficCount: "Contagem de tráfego",
      lockdown: "Bloqueio",
      zoneAuditDays: "Dias de auditoria da zona",
      reportWithAccountNumber: "Reportar com número da conta",
      chimeSong: "Melodia de aviso",
      prewarPresignal: "Pré-aviso",
      entryDelayNumber: "Número do retardo de entrada",
      number: "Número",
      loadingZones: "Carregando zonas...",
      name: "Nome",
      type: "Tipo",
      messages: {
        deleteConfirm: "Tem certeza de que deseja excluir esta zona?",
        deleteConfirmMessage: "Esta ação não pode ser desfeita",
        deleteConfirmText: "Esta ação não pode ser desfeita",
        limitReached: "Limite atingido",
        maxZonesAllowed: "Máximo de 999 zonas permitidas",
        validationError: "Erro de validação",
        validationErrorText: "Corrija os erros do formulário",
        warning: "Aviso",
        serialNumberIsKeyFob: "O número de série corresponde a um chaveiro",
        keyFobsCannotBeProgrammed: "Os chaveiros não podem ser programados nesta tela",
        zoneNumberExists: "O número da zona já existe",
        zoneSavedSuccess: "Zona salva com sucesso",
        zoneCreatedSuccess: "Zona criada com sucesso",
        zoneCreateSuccess: "Zona criada com sucesso",
        zoneUpdatedSuccess: "Zona atualizada com sucesso",
        zoneUpdateSuccess: "Zona atualizada com sucesso",
        zoneDeleteSuccess: "Zona excluída com sucesso",
        zonesLoadError: "Não foi possível carregar as zonas",
        zoneSaveError: "Não foi possível salvar a zona",
        zoneDeleteError: "Não foi possível excluir a zona",
        syncSuccess: "Zonas sincronizadas com sucesso",
        syncError: "Não foi possível sincronizar as zonas",
        warning: "Aviso"
      }
    },

    deviceSetup: {
      title: "Configuração de dispositivos",
      addDevice: "Adicionar dispositivo",
      number: "Número",
      name: "Nome",
      type: "Tipo",
      deviceDetails: "Detalhes do dispositivo",
      general: "Geral",
      options734: "Opções 734",
      loadingDevices: "Carregando dispositivos...",
      noDevicesConfigured: "Nenhum dispositivo configurado",
      maxDevicesReached: "Número máximo de dispositivos atingido",
      deviceNumber: "Número do dispositivo",
      deviceType: "Tipo de dispositivo",
      deviceCommunicationType: "Tipo de comunicação do dispositivo",
      serialNumber: "Número de série",
      supervisionTime: "Tempo de supervisão",
      accessAreas: "Áreas de acesso",
      egressAreas: "Áreas de saída",
      displayAreas: "Áreas a exibir",
      strikeTime: "Tempo da fechadura",
      strikeDelay: "Retardo da fechadura",
      fireExit: "Saída de incêndio",
      autoForceArm: "Armamento forçado automático",
      publicDoor: "Porta pública",
      privateDoor: "Porta privada",
      outputGroup: "Grupo de saída",
      doorRealTimeStatus: "Status da porta em tempo real",
      override: "Anulação",
      sendDoorForcedMessage: "Enviar mensagem de porta forçada",
      program734Options: "Programar opções 734",
      activateZone2Bypass: "Ativar bypass da zona 2",
      relockOnZone2Change: "Rebloquear ao alterar a zona 2",
      zone2BypassTime: "Tempo de bypass da zona 2",
      activateZone3ReqToExit: "Ativar zona 3 de solicitação de saída",
      zone3ReqToExitStrikeTime: "Tempo da fechadura da zona 3 de solicitação de saída",
      activateOnboardSpeaker: "Ativar alto-falante integrado",
      noCommunicationWithPanel: "Sem comunicação com o painel",
      cardFormat: "Opções de cartão",
      wiegandCodeLength: "Comprimento do código Wiegand",
      siteCodeLength: "Comprimento do código do site",
      userCodePosition: "Posição do código de usuário",
      siteCodePosition: "Posição do código do site",
      userCodeLength: "Comprimento do código de usuário",
      requireSiteCode: "Exigir código do site",
      numberOfUserCodeDigits: "Quantidade de dígitos do código de usuário",
      siteCode: "Código do site",
      enable734ToConfigureOptions: "Habilite as opções 734 para configurar ajustes adicionais",
      confirmDeleteDevice: "Tem certeza de que deseja excluir o dispositivo '{name}'?",
      deviceCreated: "Dispositivo criado com sucesso",
      deviceUpdated: "Dispositivo atualizado com sucesso",
      deviceDeleted: "Dispositivo excluído com sucesso",
      errorSavingDevice: "Erro ao salvar o dispositivo",
      errorDeletingDevice: "Erro ao excluir o dispositivo",
      cardOptions: "Opções de cartão",
      siteCodes: "Códigos do site",
      addCardFormat: "Adicionar formato de cartão",
      cardFormats: "Formatos de cartão",
      selectOrAddCardFormat: "Selecione ou adicione formatos de cartão",
      noCardFormats: "Sem formatos de cartão",
      newCardFormat: "Novo formato de cartão",
      editCardFormat: "Editar formato de cartão"
    },
    areaSchedules: {
      title: "Horários de áreas",
      addNew: "Adicionar novo",
      loading: "Carregando horários de áreas",
      noSchedulesConfigured: "Nenhum horário de área configurado",
      details: "Detalhes do horário da área",
      areaNumber: "Número da área",
      areaNumberRange: "Intervalo válido: 01-32",
      schedules: "Horários",
      schedulesHint: "Atribua até 8 horários a esta área. Deixe em branco se não for necessário.",
      schedule: "Horário",
      number: "Número",
      selectArea: "Selecione uma área para ver seus detalhes",
      selectSchedule: "Selecione um horário",
      confirmDelete: "Excluir o horário da área?",
      confirmDeleteMessage: "Esta ação não pode ser desfeita",
      messages: {
        scheduleSaveSuccess: "Horário da área salvo com sucesso",
        scheduleSaveError: "Erro ao salvar o horário da área",
        scheduleDeleteSuccess: "Horário da área excluído com sucesso",
        scheduleDeleteError: "Erro ao excluir o horário da área",
      },
      notAssigned: "Não atribuído"
    },
    timeSchedules: {
      title: "Horários",
      addNew: "Adicionar novo",
      loading: "Carregando horários",
      noSchedulesConfigured: "Nenhum horário configurado",
      details: "Detalhes do horário",
      scheduleNumber: "Número do horário",
      scheduleNumberRange: "Intervalo válido: 01-99",
      scheduleName: "Nome do horário",
      temporarySchedule: "Horário temporário",
      beginDate: "Data de início",
      endDate: "Data de término",
      openBeginActivate: "Abrir / Iniciar / Ativar",
      closeEnd: "Fechar / Encerrar",
      sunriseSunset: "Nascer / Pôr do sol",
      beforeAfter: "Antes / Depois",
      select: "Selecionar",
      sunrise: "Nascer do sol",
      sunset: "Pôr do sol",
      number: "Número",
      name: "Nome",
      selectSchedule: "Selecione um horário para ver seus detalhes",
      confirmDelete: "Excluir o horário?",
      confirmDeleteMessage: "Esta ação não pode ser desfeita",
      days: {
        sunday: "Domingo",
        monday: "Segunda-feira",
        tuesday: "Terça-feira",
        wednesday: "Quarta-feira",
        thursday: "Quinta-feira",
        friday: "Sexta-feira",
        saturday: "Sábado",
        sun: "Dom",
        mon: "Seg",
        tue: "Ter",
        wed: "Qua",
        thu: "Qui",
        fri: "Sex",
        sat: "Sáb",
      },
      holidays: {
        holidayA: "Feriado A",
        holidayB: "Feriado B",
        holidayC: "Feriado C",
      },
      messages: {
        scheduleSaveSuccess: "Horário salvo com sucesso",
        scheduleSaveError: "Erro ao salvar o horário",
        scheduleDeleteSuccess: "Horário excluído com sucesso",
        scheduleDeleteError: "Erro ao excluir o horário",
      },
      beforeAfterOptions: {
        "5minbefore": "5 min. antes",
        "10minbefore": "10 min. antes",
        "15minbefore": "15 min. antes",
        "30minbefore": "30 min. antes",
        "45minbefore": "45 min. antes",
        "60minbefore": "60 min. antes",
        "5minafter": "5 min. depois",
        "10minafter": "10 min. depois",
        "15minafter": "15 min. depois",
        "30minafter": "30 min. depois",
        "45minafter": "45 min. depois",
        "60minafter": "60 min. depois",
      },
      noTimeSelected: "Nenhuma hora selecionada",
      resetButton: "Redefinir",
      closeButton: "Fechar",
      copyTime: "Copiar hora",
      pasteTime: "Colar hora",
      applyToAll: "Aplicar a todos"
    },
    templateConfig: {
      visualize: "Visualizar",
      template: "Template",
      template_name: "Nome do template",
      created_at: "Criado em",
      updated_at: "Atualizado em",
      available: "Disponível",
      busy: "Ocupado",
      generateTemplate: "Gerar template",
      applyTemplate: "Aplicar template",
      generateTemplateWarning: "Gerar o template a partir do painel pode levar alguns minutos",
      deleteTemplate: "Excluir template",
      deleteTemplateWarning: "O template não poderá ser recuperado",
      generatingTemplate: "Gerando template",
      generatedCorrectly: "Template gerado com sucesso",
      applyExisting: "Aplicar a partir de templates existentes",
      selectTemplate: "Selecione o template",
      edit: "Editar template",
      saveTemplate: "Salvar template",
      saveTemplateMock: "Template salvo (mock)",
      saveTemplateSuccess: "Template salvo com sucesso",
      saveTemplateError: "Erro ao salvar o template",
      saveTemplateValidationError: "Corrija os erros do formulário antes de salvar",
      confirmExitTitle: "Sair sem salvar?",
      confirmExitText: "As alterações não salvas do template serão perdidas.",
      createFromScratch: "Criar do zero",
      createTemplate: "Criar template",
      creatingTemplate: "Criando template",
      createdCorrectly: "Template criado com sucesso",
      createTemplateError: "Erro ao criar o template",
      templateNamePlaceholder: "Nome do template",
      templateDescriptionPlaceholder: "Descrição (opcional)",
      nameRequired: "O nome é obrigatório",
      applying: "Aplicando template",
      appliedSuccess: "Template aplicado com sucesso",
      errorApplying: "Erro ao aplicar o template",
      tryAgain: "Verifique o conteúdo do template e tente novamente",
      step: "Etapa",
      errorStep: "Esta etapa não foi concluída"
      
    },
    systemReport: {
      title: "Relatório do sistema",
      loading: "Carregando",
      zoneRestorals: "Restaurações de zona",
      accessKeypadEnable: "Habilitar teclado de acesso",
      optionsSection: "Opções",
      abortReports: "Relatórios de cancelamento",
      bypassReports: "Relatórios de bypass",
      scheduleChangeReports: "Relatórios de alteração de horário",
      codeChangeReports: "Relatórios de alteração de código",
      ambushReports: "Relatórios de coação",
      videoSystemReports: "Relatórios do sistema de vídeo",
      lateToOpen: "Atraso na abertura",
      earlyToClose: "Fechamento antecipado",
      savedSuccessfully: "Relatório do sistema salvo",
      errorSaving: "Erro ao salvar o relatório do sistema"
    },
    menuDisplay: {
      title: "Exibição do menu",
      loading: "Carregando",
      optionsSection: "Opções",
      armedAreaStatusDisplay: "Exibir status de área armada",
      timeDisplay: "Exibir hora",
      armDisarmDisplay: "Exibir armado/desarmado",
      savedSuccessfully: "Exibição do menu salva",
      errorSaving: "Erro ao salvar a exibição do menu"
    },
    statusList: {
      title: "Lista de status",
      loading: "Carregando",
      optionsSection: "Opções",
      systemTroubleStatusMonitors: "Monitores de status de falha do sistema",
      fireZoneKeypads: "Teclados de zona de incêndio",
      carbonMonoxideZoneKeypads: "Teclados de zona de monóxido de carbono",
      burglaryZoneKeypads: "Teclados de zona de roubo",
      supervisoryZoneKeypads: "Teclados de zona de supervisão",
      panicZoneKeypads: "Teclados de zona de pânico",
      emergencyZoneKeypads: "Teclados de zona de emergência",
      auxiliary1ZoneKeypads: "Teclados de zona auxiliar 1",
      auxiliary2ZoneKeypads: "Teclados de zona auxiliar 2",
      commPathTrouble: "Falha no caminho de comunicação",
      yes: "Sim",
      no: "Não",
      all: "Todos",
      savedSuccessfully: "Lista de status salva",
      errorSaving: "Erro ao salvar a lista de status"
    },
    pcLogReport: {
      title: "Relatórios de log de PC",
      loading: "Carregando",
      optionsSection: "Opções",
      netOptionsSection: "Opções de rede",
      armDisarmReports: "Relatórios de armado/desarmado",
      zoneReports: "Relatórios de zona",
      useCommandReports: "Relatórios de uso de comandos",
      doorAccessReports: "Relatórios de acesso a portas",
      supervisoryReports: "Relatórios de supervisão",
      realTimeStatus: "Status em tempo real",
      netIpAddress: "Endereço IP de rede",
      netPort: "Porta de rede",
      savedSuccessfully: "Relatório de log de PC salvo",
      errorSaving: "Erro ao salvar o relatório de log de PC"
    },
    templates: "Templates",
    inProgress: "Em andamento",
    virtual_bypass: "Bypass virtual",
    virtual_bypass_on: "Habilitado",
    virtual_bypass_off: "Desabilitado",
    compositeAlarms: "Alarmes compostos"
  }
}
